<template>
  <form method="post" @submit.prevent="send">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title is-centered">
          {{ formTitle }}
        </p>
      </header>
      <section class="modal-card-body">
        <form-wrapper :validator="$v.form">
          <form-group
            horizontal
            name="emp_code"
            attribute="attributes.employee_code"
            :label="$t('attributes.employee_code')"
          >
            <b-field :type="empCodeStatus">
              <b-input
                v-model="form.emp_code"
                name="emp_code"
                :placeholder="
                  $t('message.please_input') + $t('attributes.employee_code')
                "
                :disabled="isEditing"
                @blur="verifyEmpCode"
                expanded
              >
              </b-input>
            </b-field>
          </form-group>
          <b-field horizontal :label="$t('attributes.account')">
            <form-group name="account">
              <b-input
                v-model="form.account"
                name="account"
                :placeholder="
                  $t('message.please_input') + $t('attributes.account')
                "
                expanded
              >
              </b-input>
            </form-group>
            <form-group
              horizontal
              name="password"
              :label="$t('attributes.password')"
            >
              <b-input
                v-model="form.password"
                name="password"
                :placeholder="
                  $t('message.please_input') + $t('attributes.password')
                "
                expanded
              >
              </b-input>
            </form-group>
          </b-field>

          <form-group
            horizontal
            name="name"
            :label="$t('attributes.employee_name')"
          >
            <b-input
              v-model="form.name"
              name="name"
              :placeholder="
                $t('message.please_input') + $t('attributes.employee_name')
              "
              expanded
            >
            </b-input>
          </form-group>
          <form-group
            horizontal
            name="english_name"
            :label="$t('attributes.english_name')"
          >
            <b-input
              v-model="form.english_name"
              name="english_name"
              :placeholder="
                $t('message.please_input') + $t('attributes.english_name')
              "
              expanded
            >
            </b-input>
          </form-group>

          <form-group
            horizontal
            name="start_date"
            :label="$t('attributes.employee_start_date')"
          >
            <b-datepicker
              v-model="str_date"
              :placeholder="
                $t('message.please_select') +
                  $t('attributes.employee_start_date')
              "
              icon="calendar-today"
              trap-focus
              @input="onSelectedStartDate"
              :disabled="isEditing"
            ></b-datepicker>
          </form-group>
          <form-group horizontal name="email" :label="$t('attributes.email')">
            <b-input
              v-model="form.email"
              name="email"
              :placeholder="$t('message.please_input') + $t('attributes.email')"
              expanded
            >
            </b-input>
          </form-group>
          <form-group
            horizontal
            name="status"
            :label="$t('attributes.employee_status')"
          >
            <b-switch
              v-model="form.status"
              name="status"
              true-value="1"
              false-value="0"
            ></b-switch>
          </form-group>
          <form-group
            horizontal
            name="company"
            :label="$t('attributes.companies')"
          >
            <b-select v-model="form.company_no" name="company">
              <option value="">請選擇分公司</option>
              <option v-for="c in companies" :key="c.id" :value="c.id">
                {{ c.name }}
              </option>
            </b-select>
          </form-group>
          <b-field horizontal :label="$t('attributes.depart')">
            <form-group name="depart_no" attribute="attributes.depart">
              <b-select v-model="form.depart_no" name="depart_no" expanded>
                <option value="">請選擇部門</option>
                <option v-for="item in departs" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
              </b-select>
            </form-group>
            <form-group
              horizontal
              name="position_no"
              attribute="attributes.position"
              :label="$t('attributes.position')"
            >
              <b-select v-model="form.position_no" name="position_no" expanded>
                <option value="">請選擇職位</option>
                <option
                  v-for="item in positions"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </b-select>
            </form-group>
          </b-field>
          <form-group
            horizontal
            name="is_web"
            :label="$t('attributes.employee_is_web')"
          >
            <b-switch
              v-model="form.is_web"
              name="is_web"
              true-value="Y"
              false-value="N"
            ></b-switch>
          </form-group>
          <form-group
            horizontal
            name="superior"
            :label="$t('attributes.employee_superior')"
          >
            <b-select
              v-model="selectedSuperior"
              :loading="loadingSuperiors"
              :placeholder="
                $t('message.please_select') + $t('attributes.employee_superior')
              "
              @input="onSelectSuperior"
              expanded
            >
              <option
                v-for="option in superiors"
                :value="option"
                :key="option.emp_code"
              >
                {{ option.name }}
              </option>
            </b-select>
          </form-group>
          <form-group horizontal name="tel1" :label="$t('attributes.tel')">
            <b-input
              v-model="form.tel1"
              name="tel1"
              :placeholder="$t('message.please_input') + $t('attributes.tel')"
            >
            </b-input>
          </form-group>
        </form-wrapper>
      </section>
      <footer class="modal-card-foot">
        <b-button @click="$parent.close()">
          {{ $t('attributes.close') }}
        </b-button>
        <b-button type="is-primary" :loading="sending" native-type="submit">
          {{ submitTitle }}
        </b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'
import { EMPLOYEES_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'EmployeeForm',
  props: {
    sending: Boolean,
    companies: {
      type: Array,
      required: true
    },
    departs: {
      type: Array,
      required: true
    },
    positions: {
      type: Array,
      required: true
    },
    permissionList: {
      type: Array,
      required: true
    },
    employee: {
      type: Object,
      required: true
    }
  },
  data() {
    const isEditing = this.employee.emp_code !== null
    const formTitle =
      this.$t(isEditing ? 'attributes.modify' : 'attributes.add') +
      this.$t('attributes.employee')
    const submitTitle = this.$t(
      isEditing ? 'attributes.update' : 'attributes.add'
    )

    const str_date = this.$dayjs(this.employee.str_date).toDate()

    return {
      isEditing,
      formTitle,
      submitTitle,
      str_date: str_date,
      form: {
        emp_code: this.employee.emp_code,
        account: this.employee.account,
        password: this.employee.password,
        name: this.employee.name,
        english_name: this.employee.english_name,
        company_no: this.employee.company_no,
        str_date: this.formatDate(str_date),
        email: this.employee.email,
        status: this.employee.status,
        depart_no: this.employee.depart_no,
        position_no: this.employee.position_no,
        is_web: this.employee.is_web,
        superior: this.employee.superior,
        tel1: this.employee.tel1
      },
      empCodeStatus: '',
      loadingSuperiors: false,
      selectedSuperior: null,
      superiors: []
    }
  },
  validations: {
    form: {
      emp_code: { required, maxLength: maxLength(6) },
      account: { required, maxLength: maxLength(50) },
      password: { required, maxLength: maxLength(50) },
      name: { required, maxLength: maxLength(50) },
      english_name: { maxLength: maxLength(50) },
      company_no: {},
      str_date: { required },
      email: { required, maxLength: maxLength(150) },
      status: {},
      depart_no: { required },
      position_no: { required },
      is_web: {},
      superior: { maxLength: maxLength(10) },
      tel1: { maxLength: maxLength(25) }
    }
  },
  mounted() {
    this.loadSuperiors()
  },
  methods: {
    async loadSuperiors() {
      try {
        const api = `${EMPLOYEES_API}/list`
        const params = {
          company: '',
          name: '',
          status: 1
        }
        this.loadingSuperiors = true
        const res = await this.axios.get(api, { params })
        const employees = res.data.data
        const positions = 'P1,P2,P3,P4,P5,p1,p2,p3,p4,p5'
        this.superiors = employees.filter(
          e => positions.indexOf(e.position_no) !== -1
        )
        if (this.employee.superior !== null) {
          this.selectedSuperior = employees.filter(
            e => e.emp_code === this.employee.superior
          )[0]
        }
      } catch (e) {
        this.superiors = []

        notifyService.fetch_error('employee', e)
      } finally {
        this.loadingSuperiors = false
      }
    },
    onSelectSuperior(item) {
      this.form.superior = item.emp_code
    },
    async verifyEmpCode() {
      if (!this.form.emp_code) {
        this.empCodeStatus = ''
        return
      }
      const api = `${EMPLOYEES_API}/${this.form.emp_code}/verify`
      const res = await this.axios.get(api)
      const notExist = res.data.data
      if (notExist) {
        this.empCodeStatus = 'is-success'
      } else {
        this.empCodeStatus = 'is-danger'
      }
    },
    onSelectedStartDate(date) {
      this.form.str_date = this.formatDate(date)
    },
    async send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }
      if (!this.employee.emp_code && this.empCodeStatus !== 'is-success') {
        return
      }
      this.$emit('onSend', this.form)
    }
  }
}
</script>
